module.exports = __webpack_public_path__ + "img/highlights2-s.94e8fb66.png";